(function () {
    "use strict";

    angular
        .module('components')
        .component('hNavbarMenu', {
            controller: HNavbarMenuController,
            controllerAs: '$ctrl',
            bindings: {
                title: '@',
                titleIcon: '@',
                items: '<',
                onMenuActivationChange: '&?',
                enableOpenOnHover: '<',
                area: '@?',
                enableToggleOnWidth: '<?',
                forceCollapse: '<?'
            },
            templateUrl: '../hmodules/components/h-navbar-menu/h-navbar-menu.component.ng.html'
        });

    HNavbarMenuController.$inject = ['$scope', '$state', 'hTransitions'];

    function HNavbarMenuController($scope, $state, hTransitions) {
        var self = this;
        var area = '';

        function initHNavbarActiveStatus() {
            if (self.forceCollapse) return;

            if (!self.enableToggleOnWidth || (self.enableToggleOnWidth && self.enableToggleOnWidth <= window.innerWidth)) {
                area = self.area + '_hNavbarMenu';

                var isNavbarMenuActive = HStorageManager.get({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: '{{area}}',
                    variables: {
                        area: area
                    }
                });

                self.isNavbarMenuActive = isNavbarMenuActive !== null ? isNavbarMenuActive === 'true' : true;
                self.showToggleButton = true;
            }
        }

        self.$onInit = function () {
            self.showToggleButton = false;
            self.isNavbarMenuActive = false;

            initHNavbarActiveStatus();

            self.closingClass = '';
            self.currentState = $state.current.name;

            hTransitions.onSuccess({}, function () {
                self.currentState = $state.current.name;
            });
        };

        self.$onChanges = function (changeObj) {
            if(changeObj.forceCollapse && changeObj.forceCollapse.currentValue) {
                this.isNavbarMenuActive = false;
                return;
            }

            initHNavbarActiveStatus();
        };

        self.$onDestroy = function () {
        };

        self.onToggle = function () {
            self.isNavbarMenuActive = !self.isNavbarMenuActive;
            if (self.onMenuActivationChange) {
                self.onMenuActivationChange({'isNavbarMenuActive': self.isNavbarMenuActive});
            }
            if (self.area) {
                HStorageManager.put({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: '{{area}}',
                    value: self.isNavbarMenuActive,
                    variables: {
                        area: area
                    }
                });
            }

            if (!self.isNavbarMenuActive && self.enableOpenOnHover) {
                self.closingClass = 'closing-navbar-menu';

                setTimeout(function () {
                    self.closingClass = '';
                    $scope.$digest();
                }, 300);
            }
        };
    }
})();
